import {useEffect, useState} from 'react'
import {Schedule} from "../../app/types";
import {api} from "../api";
import {useUrlHelpers} from "../util/hooks";

export function useCustomerHolidaySchedules(): { schedules: Schedule[] } {
    const [schedules, setSchedules] = useState<Schedule[]>([])
    const {createUrl} = useUrlHelpers();

    useEffect(() => {
        const fetch = async () => {
            try {
                const {data} = await api.get(createUrl('holidays'))
                setSchedules(data || [] as Schedule[])
            } catch (err: any) {
            }
        }
        fetch();
    }, [createUrl])

    return {schedules}
}
